import type { PracticeAccessSource } from '@nesso/practice-contracts/practice-access-rule.access-sources';

export function getMissingAccessSources<S extends PracticeAccessSource[]>(
    accessSources: PracticeAccessSource[],
    requiredAccessSources: S,
): S[number][] {
    return requiredAccessSources.filter((source) => !accessSources.includes(source));
}
